(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/login-check.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/login-check.js');

'use strict';

const {
  reactComponent
} = svs.legal_info.data.loginCheckOptions;
const {
  AcceptTerms,
  ReviewTerms
} = svs.legal_info.components.login_check.check_terms;
const {
  GamingPaused,
  GamingBlocked,
  TTRestriction,
  GcsRestriction
} = svs.legal_info.components.login_check.self_exclusion_info;
const LoginCheck = () => {
  const setPauseComponent = model => {
    if (model.hasTTRestriction) {
      return TTRestriction;
    }
    if (model.hasGCSRestriction) {
      return GcsRestriction;
    }
    return GamingPaused;
  };
  const getComponentToRender = reactComponent => {
    const componentMap = {
      acceptTerms: AcceptTerms,
      reviewTerms: ReviewTerms,
      gamingPaused: setPauseComponent(svs.legal_info.data.loginCheckOptions.model),
      gamingBlocked: GamingBlocked
    };
    return componentMap[reactComponent];
  };
  const ComponentToRender = getComponentToRender(reactComponent);
  return React.createElement("section", {
    className: "login-check-container align-center padding-top-4",
    role: "main"
  }, React.createElement("div", {
    className: "login-check-content"
  }, ComponentToRender && React.createElement(ComponentToRender, null)));
};
svs.legal_info.components.login_check.LoginCheck = LoginCheck;

 })(window);